// Banner CTA links are entered by admin as an in-app route ("/lottery") or as a
// full URL that still points at our own site ("https://stage.../buy-coins").
// Either way we only ever navigate inside the app, so the value is reduced to a
// path and checked against the routes that actually exist.

// Static routes only — parameterised ones (/blog/:slug, /:category) are not
// offered as CTA targets because a bare pattern is not a real destination.
const APP_ROUTES = [
  "/",
  "/about-us",
  "/add-card",
  "/add-crypto",
  "/all-promotions",
  "/blog",
  "/buy-coins",
  "/congratulations",
  "/contact-us",
  "/crypto-gaming-rules",
  "/faq",
  "/game",
  "/game-history",
  "/generate-code",
  "/gift-card",
  "/home",
  "/kyc",
  "/leaderboard",
  "/lottery",
  "/loyalty",
  "/my-redeemption",
  "/post-history",
  "/privacy-policy",
  "/profile",
  "/purchase-history",
  "/recently-played",
  "/redeem",
  "/refer-friend",
  "/responsible-gaming",
  "/responsible-gaming-settings",
  "/search",
  "/support",
  "/sweepstakes",
  "/terms-conditions",
  "/transaction",
  "/vip",
];

/**
 * Turns whatever admin typed into a route this app can navigate to.
 * Returns null when there is nothing to link to, so the banner stays inert.
 * Falls back to "/" when a link was set but does not match a real route.
 */
export const resolveBannerRoute = (link) => {
  const raw = (link || "").trim();
  if (!raw) return null;

  let path = raw;
  // Strip the origin off a full URL so only the in-app path is used.
  if (/^https?:\/\//i.test(raw)) {
    try {
      path = new URL(raw).pathname;
    } catch (e) {
      return "/";
    }
  }

  if (!path.startsWith("/")) path = `/${path}`;
  // Drop any query/hash and a trailing slash, keeping "/" itself intact.
  path = path.split("?")[0].split("#")[0].replace(/\/+$/, "") || "/";

  const match = APP_ROUTES.find((route) => route.toLowerCase() === path.toLowerCase());
  return match || "/";
};

export default resolveBannerRoute;
